var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "185px",
    height: "35px",
    viewBox: "0 0 185 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.8,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.4,
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "20%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.02,
    offset: "95.0255322%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.04,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 1440,
    height: 72
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.3%",
    y: "-5.6%",
    width: "100.6%",
    height: "113.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.0980392157   0 0 0 0 0.156862745  0 0 0 0.07 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter2",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.0980392157   0 0 0 0 0.156862745  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 18.5185185 0 0 11.3168724 0 11.3168724 18.5185185"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Full-Details",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-Details-Property-Financials-Three-Broker",
    transform: "translate(-160.000000, -19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-Navigation"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Header"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(160.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fundever-Logo-Icon",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,9.16560112 C0,4.07295936 2.30026294,0 7.38219236,0 C11.1681593,0 39.7176048,0 39.7176048,0 C39.7176048,5.09346608 37.4185505,9.16560112 32.3358153,9.16560112 C28.5494456,9.16560112 0,9.16560112 0,9.16560112",
    id: "Fill-11",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21.3864026 C0,16.2929365 2.30654836,12.2208015 7.40236406,12.2208015 C11.1986761,12.2208015 27.4968034,12.2208015 27.4968034,12.2208015 C27.4968034,17.3142676 25.1918708,21.3864026 20.0952472,21.3864026 C16.2993391,21.3864026 0,21.3864026 0,21.3864026",
    id: "Fill-12",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,34.6371209 C0,29.5436548 2.32286679,25.4715197 7.45473447,25.4715197 C11.2779047,25.4715197 15.2760019,25.4715197 15.2760019,25.4715197 C15.2760019,30.5649858 12.9535419,34.6371209 7.82126739,34.6371209 C3.99809716,34.6371209 0,34.6371209 0,34.6371209",
    id: "Fill-13",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4968034,12.2208015 L17.0062498,9.16560112 C8.60572791,9.16560112 0,9.16560112 0,9.16560112 L8.84123013,12.2208015 C14.2185982,12.2208015 27.4959955,12.2208015 27.4968034,12.2208015",
    id: "Fill-14",
    fill: "#72B8C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.45410957,25.4451559 C11.1514651,25.4451559 15.0115563,25.4451559 15.2625762,25.4451559 L15.2760019,25.4306116 L10.5037769,21.3864026 C5.2677552,21.3864026 0.035801858,21.3864026 0,21.3864026 L4.68638184,25.9692032 C5.49802624,25.6310495 6.41788989,25.4451559 7.45410957,25.4451559",
    id: "Fill-15",
    fill: "#72B8C5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M66.5955553,8.9773356 L67.1256144,8.9773356 C67.3023948,8.9773356 67.4538,9.1337735 67.4538,9.31643005 L67.4538,20.55811 C67.4538,23.9225445 69.4984749,26.2962056 72.8556102,26.2962056 C76.2384026,26.2962056 78.3084527,23.9484718 78.3084527,20.5840373 L78.3084527,9.31643005 C78.3084527,9.10784618 78.4093895,8.9773356 78.6617315,8.9773356 L79.1666974,8.9773356 C79.3431958,8.9773356 79.494883,9.1337735 79.494883,9.31643005 L79.494883,20.6883293 C79.494883,24.679098 76.8693985,27.4958541 72.8556102,27.4958541 C68.8671971,27.4958541 66.2673697,24.679098 66.2673697,20.6883293 L66.2673697,9.31643005 C66.2673697,9.1337735 66.4187749,8.9773356 66.5955553,8.9773356 Z",
    id: "Fill-4",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3266455,8.9773356 L84.4967785,8.9773356 C84.6666401,8.9773356 84.7882024,9.02875758 84.8856151,9.18302351 L96.4009308,25.0525921 C96.4170305,25.0525921 96.4250804,19.8913387 96.4250804,9.56883196 C96.4250804,9.38871141 96.5707924,9.23444548 96.7409254,9.23444548 L97.2269033,9.23444548 C97.3967649,9.23444548 97.5424769,9.38871141 97.5424769,9.56883196 L97.5424769,27.1614676 C97.5424769,27.3930102 97.3484656,27.4958541 97.1539116,27.4958541 L97.0809199,27.4958541 C96.9110583,27.4958541 96.789496,27.4444321 96.6923547,27.2898789 L85.0798977,11.2663317 L85.0554767,26.9040705 C85.0554767,27.0844783 84.9097647,27.2387442 84.7396318,27.2387442 L84.2780749,27.2387442 C84.1079419,27.2387442 83.9622299,27.0844783 83.9622299,26.9040705 L83.9622299,9.31172208 C83.9622299,9.10574691 84.1323629,8.9773356 84.3266455,8.9773356 Z",
    id: "Fill-5",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.609433,26.3582622 C112.514675,26.3582622 116.152132,22.8397053 116.152132,18.2101495 C116.152132,13.6334844 112.542068,10.115223 107.609433,10.115223 L102.952576,10.115223 L102.952576,26.3582622 L107.609433,26.3582622 Z M101.65709,9.32127247 C101.65709,9.13600751 101.822681,8.9773356 101.987964,8.9773356 L107.830118,8.9773356 C113.176115,8.9773356 117.530106,13.1308756 117.530106,18.2101495 C117.530106,23.3686117 113.176115,27.4958541 107.830118,27.4958541 L101.987964,27.4958541 C101.822681,27.4958541 101.65709,27.3371822 101.65709,27.1516218 L101.65709,9.32127247 Z",
    id: "Fill-6",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.203802,9.32127247 C121.203802,9.13600751 121.362023,8.9773356 121.546418,8.9773356 L132.104867,8.9773356 C132.288968,8.9773356 132.447188,9.13600751 132.447188,9.32127247 L132.447188,9.77099062 C132.447188,9.95625558 132.288968,10.115223 132.104867,10.115223 L122.467805,10.115223 L122.467805,17.4164945 L130.81469,17.4164945 C130.998791,17.4164945 131.157012,17.5754619 131.157012,17.7604314 L131.157012,18.2101495 C131.157012,18.395119 130.998791,18.5540864 130.81469,18.5540864 L122.467805,18.5540864 L122.467805,26.3845598 L132.104867,26.3845598 C132.288968,26.3845598 132.447188,26.5435272 132.447188,26.7287922 L132.447188,27.1516218 C132.447188,27.3371822 132.288968,27.4958541 132.104867,27.4958541 L121.546418,27.4958541 C121.362023,27.4958541 121.203802,27.3371822 121.203802,27.1516218 L121.203802,9.32127247",
    id: "Fill-7",
    fill: "#72B8C5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.406191,9.31643005 C136.302646,9.10784618 136.380233,8.9773356 136.612706,8.9773356 L137.309836,8.9773356 C137.464722,8.9773356 137.567979,9.08162754 137.593649,9.15999215 L144.566396,25.3569955 C144.566396,25.3569955 144.592066,25.3569955 144.617736,25.3569955 L151.667781,9.15999215 C151.693451,9.08162754 151.796709,8.9773356 151.951883,8.9773356 L152.623343,8.9773356 C152.855528,8.9773356 152.958785,9.1337735 152.855528,9.34264869 L144.927796,27.2613429 C144.876168,27.3915622 144.77291,27.4958541 144.617736,27.4958541 L144.488809,27.4958541 C144.333923,27.4958541 144.230377,27.3394162 144.204707,27.2613429 L136.406191,9.31643005",
    id: "Fill-8",
    fill: "#72B8C5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.559433,9.32127247 C156.559433,9.13600751 156.717364,8.9773356 156.901764,8.9773356 L167.460489,8.9773356 C167.644889,8.9773356 167.80282,9.13600751 167.80282,9.32127247 L167.80282,9.77099062 C167.80282,9.95625558 167.644889,10.115223 167.460489,10.115223 L157.823175,10.115223 L157.823175,17.4164945 L166.170279,17.4164945 C166.354679,17.4164945 166.512609,17.5754619 166.512609,17.7604314 L166.512609,18.2101495 C166.512609,18.395119 166.354679,18.5540864 166.170279,18.5540864 L157.823175,18.5540864 L157.823175,26.3845598 L167.460489,26.3845598 C167.644889,26.3845598 167.80282,26.5435272 167.80282,26.7287922 L167.80282,27.1516218 C167.80282,27.3371822 167.644889,27.4958541 167.460489,27.4958541 L156.901764,27.4958541 C156.717364,27.4958541 156.559433,27.3371822 156.559433,27.1516218 L156.559433,9.32127247",
    id: "Fill-9",
    fill: "#72B8C5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.544038,19.1361789 C181.036735,19.1361789 183.139404,17.1786344 183.139404,14.5595138 C183.139404,12.0461744 181.036735,10.1944112 178.51823,10.1944112 L173.065963,10.1944112 L173.065963,19.1361789 L178.544038,19.1361789 Z M171.819615,9.32127247 C171.819615,9.13600751 171.949527,8.9773356 172.157445,8.9773356 L178.596235,8.9773356 C181.763433,8.9773356 184.385752,11.3317076 184.385752,14.5595138 C184.385752,17.2312296 182.568427,19.4535227 180.101829,20.1679895 L183.892491,27.0195429 C184.022113,27.2314009 183.970496,27.4958541 183.710961,27.4958541 L183.03559,27.4958541 C182.724148,27.4958541 182.620334,27.4163704 182.490421,27.1782148 L178.777765,20.3266614 C178.440224,20.352959 178.154591,20.352959 177.81734,20.352959 L173.040155,20.352959 L173.040155,27.1516218 C173.040155,27.3371822 172.884144,27.4958541 172.624609,27.4958541 L172.157445,27.4958541 C171.975626,27.4958541 171.819615,27.3371822 171.819615,27.1516218 L171.819615,9.32127247 Z",
    id: "Fill-10",
    fill: "#72B8C5",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "F",
    transform: "translate(51.007188, 8.977336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0.343936872 C0,0.158671907 0.159254986,0 0.344559114,0 L10.9720173,0 C11.1576174,0 11.3168724,0.158671907 11.3168724,0.343936872 L11.3168724,0.793655015 C11.3168724,0.978919979 11.1576174,1.13788736 10.9720173,1.13788736 L1.24562264,1.13788736 L1.24562264,9.17992331 L9.67340834,9.17992331 C9.85900848,9.17992331 10.0182635,9.33859521 10.0182635,9.52386018 C10.0182635,9.81461093 10.0709538,10.2912176 9.67340834,10.2912176 L1.24562264,10.2912176 L1.24562264,18.1742862 C1.24562264,18.3598466 1.08666367,18.5185185 0.821732046,18.5185185 L0.344559114,18.5185185 C0.159254986,18.5185185 0,18.3598466 0,18.1742862 L0,0.343936872",
    id: "Fill-1",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-6)"
  }))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f2c462978b9b2579f2d8ab491a34d96d.svg";
export { ForwardRef as ReactComponent };